import { combineReducers } from '@reduxjs/toolkit';
import { AppThunkApi, AppThunkApiConfig, PdpDispatch, PdpState, PdpStore, PdpThunk } from '@ff-os/pdp-shared-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { reducer as cuid } from './slices/cuidSlice';
import { reducer as inputs } from './slices/inputsSlice';
import { reducer as meta } from './slices/metaSlice';
import { reducer as ui } from './slices/uiSlice';
import { reducer as variables } from './slices/variablesSlice';
import { reducer as version } from './slices/versionSlice';

const projectReducers = {
    cuid,
    version,
    meta,
    variables,
    inputs
};

export const giftPluginReducers = {
    project: combineReducers(projectReducers),
    ui: ui
};

export type GiftPdpStore = PdpStore<GiftJson.Project>;
export type GiftPdpDispatch = PdpDispatch<GiftJson.Project>;
export type GiftPdpState = PdpState<GiftJson.Project>;
export type GiftPdpThunk<ReturnType = void> = PdpThunk<GiftJson.Project, ReturnType>;
export type GiftThunkApi = AppThunkApi<GiftJson.Project>;
export type GiftThunkApiConfig = AppThunkApiConfig<GiftJson.Project>;